<template>
    <div class="container">
        <div class="card blue-grey darken-1">
          <div class="card-content white-text">
            <span class="card-title">Opens of the week</span>
            <p>Hey {{ name }}! Remind that you still have {{ count }} {{ 'session' | pluralize(count) }}  to complete this week.</p>
          </div>
          <div class="card-action">
            <router-link :to="{name:'Sessions'}">
              <i class="material-icons">fitness_center</i> Go to workout
            </router-link>
          </div>
        </div>
      </div>
</template>

<script>
export default {
  name: 'sessionRemaining',
  props: {
    'name': String,
    'count': Number
  }
}
</script>


// WEBPACK FOOTER //
// src/components/cards/SessionRemaining.vue